import React from 'react';

import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import styles from './IconActionList.scss';

export interface ListItem {
  icon: string;
  text: string;
  action?: React.MouseEventHandler;
}

interface Props {
  dataList: ListItem[];
}

const IconActionList: React.FC<Props> = ({ dataList }) => (
  <div className={styles.listContainer}>
    {dataList.map(({ action, icon, text }: ListItem, key: number) => (
      <li key={key} className={styles.dataRow}>
        <div className={styles.icon} style={getBackgroundImageStyle(icon)} />
        <div className={action ? styles.textLink : styles.text} onClick={action}>
          {text}
        </div>
      </li>
    ))}
  </div>
);

export default IconActionList;
